import styled from '@emotion/styled';

export const StyledContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing.md};
`;
